import React, { useState } from "react";
import { Avatar } from "@fluentui/react-components";
import HoverCard from "../hoverCard/HoverCard";
import styles from "./resourceInsights.module.scss";

/** Skills shown before the rest are asked for. */
const SKILLS_SHOWN = 8;

/** The skills of the resource as pills; a long list ends in a pill that shows the rest. */
function SkillPills({ skills }) {
  const [expanded, setExpanded] = useState(false);
  const shown = expanded ? skills : skills.slice(0, SKILLS_SHOWN);
  const hidden = skills.length - shown.length;

  return (
    <div className={styles.skills} aria-label="Skills">
      {shown.map((skill) => (
        <span key={skill} className="pill secondary">
          {skill}
        </span>
      ))}
      {hidden > 0 && (
        <button type="button" className={styles.skillsMore} onClick={() => setExpanded(true)}>
          +{hidden}
        </button>
      )}
    </div>
  );
}

/**
 * Who Resource Insights is about: the resource's picture, name and title, with their skills as pills. Hovering the name
 * shows the same hover card as everywhere else in the app, with how to reach them.
 *
 * @param verdict  the colours of the global performance index (see `performanceVerdict`); the header, and the ring of
 *   the picture, wear them when there are some
 */
export default function InsightsHeader({ resourceId, identity, skills, verdict }) {
  const toneStyle = verdict ? { "--tone": verdict.color, "--tone-soft": verdict.soft, "--tone-faint": verdict.faint, "--tone-line": verdict.line } : undefined;

  return (
    <div className={`${styles.header} ${verdict ? styles.headerTone : ""}`} style={toneStyle}>
      <HoverCard
        HoverCardTrigger={
          <div className={styles.identity}>
            <Avatar size={56} color="colorful" name={identity.name} image={{ src: identity.image || null }} className={styles.avatar} />
            <div className={styles.identityText}>
              <h3 className={styles.name}>{identity.name}</h3>
              {identity.title && <span className={styles.title}>{identity.title}</span>}
            </div>
          </div>
        }
        AvatarId={resourceId}
        AvatarName={identity.name}
        AvatarImage={identity.image}
        AvatarDesignation={identity.title}
        AvatarEmail={identity.email}
        AvatarPhone={identity.phoneNumber}
        AvatarIsExternal={identity.isExternal}
        CanSendMessage={true}
      />

      {skills?.length > 0 && <SkillPills skills={skills} />}
    </div>
  );
}
